import { render } from "./ProfileInitials.vue?vue&type=template&id=60c03ece&scoped=true"
import script from "./ProfileInitials.vue?vue&type=script&lang=js"
export * from "./ProfileInitials.vue?vue&type=script&lang=js"

import "./ProfileInitials.vue?vue&type=style&index=0&id=60c03ece&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c03ece"]])

export default __exports__